<template>
  <div class="wrapper stores stores--list">
    <div class="body__top body__top--border">
      <h1 class="body__title">
        <slot name="title"></slot>
      </h1>
    </div>
    <div class="store__wrapper">
      <div class="store__lists">
        <div
          v-for="(item, stIndex) in allStores"
          v-bind:key="`${item.state}-store-${stIndex}`"
          :class="[
            'store__state store__state--desktop',
            selectedState === item.state ? 'store__state--selected' : ''
          ]"
          v-html="item.state"
          @click="selectState(item.state)"
        >
        </div>
        <div class="select-wrap store__state--mobile">
          <AngleDown class="icon-dropdown" />
          <select
            class="field__select state__select"
            v-model="selectedState"
            name="state"
            @change="selectState()"
          >
            <option
              v-for="(item, stIndex) in allStores"
              v-bind:key="`${item.state}-storeM-${stIndex}`"
              v-bind:value="item.state"
            >
              {{ item.state }}
            </option>
          </select>
        </div>
      </div>
      <transition-group name="list" tag="div" class="store__list">
        <StoreItem
          v-for="(store, storeIndex) in currentStores.stores"
          v-bind:store="store"
          v-bind:key="`${selectedState}-store-${storeIndex}`"
        >
        </StoreItem>
      </transition-group>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// Data
import auStoreData from '@/data/au-stores.json';
import nzStoreData from '@/data/nz-stores.json';

// Components
import StoreItem from '@/components/stores/StoreItem.vue';
import AngleDown from '@/assets/icons/angle-down.svg';

export default {
  name: 'StoresList',
  components: {
    StoreItem,
    AngleDown,
  },
  mounted() {
    const self = this;
    let initState;

    self.allStores = self.auStores.concat(self.nzStores);

    self.allStores = self.allStores.map((s) => {
      const newS = s;

      newS.stores = s.stores.concat([
        { placeholder: true },
        { placeholder: true },
        { placeholder: true },
      ]);

      return newS;
    });

    if (self.$route.query.region) {
      initState = self.$route.query.region.toUpperCase();
    }

    self.selectedState = initState || self.defaultState;
    self.getCurrentStores();
  },
  data() {
    return {
      auStores: auStoreData.auStores,
      nzStores: nzStoreData.nzStores,
      allStores: [],
      currentStores: [],
      defaultState: 'VIC',
      selectedState: '',
    };
  },
  methods: {
    selectState(stateVal) {
      const self = this;

      if (stateVal) {
        self.selectedState = stateVal;
      }

      self.getCurrentStores();
    },
    getCurrentStores() {
      const self = this;

      [self.currentStores] = self.allStores.filter(s => s.state === self.selectedState ||
        s.placeholder);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$heading-border: #e5e5e5;

.stores--list {
  flex: 1;
}

.body__top--border {
  border-bottom: 1px solid $heading-border;
}

.store__wrapper {
  margin: 0;
}

.store__state {
  position: relative;
  padding: ($spacing-half / 2) 0;
  border-bottom: 3px solid $white;
  margin: 0 $spacing-half;
  transition: border 150ms ease-in;
  cursor: pointer;
  font-size: $title-font-size;
  line-height: $h3-line-height;
  font-weight: 500;

  @include medium-up {
    padding: ($spacing-half / 2) 0;
    margin: 0 $spacing;
  }

  &--desktop {
    @include small-down {
      display: none;
    }
  }

  &--mobile {
    width: 100%;

    @include small-up {
      display: none;
    }
  }
}

.store__state--selected {
  border-color: $body-text;
}

.store__lists {
  display: flex;
  margin-bottom: $spacing * 1.5;
  justify-content: center;

  @include medium-up {
    margin-bottom: $spacing-double;
  }
}

.store__list {
  // display: flex;
  // padding: 0;
  // flex-wrap: wrap;
  // justify-content: space-between;
  max-width: 760px;
  margin: 0 auto;
}

.state__select {
  @include heading('h3');
  color: $body-text;
  height: auto;
}

.store__item {
  opacity: 1;
  visibility: visible;
}

.placeholder {
  visibility: hidden;
  height: 0;
  padding: 0;
  margin: 0;
  border-top-width: 0;
  border-bottom-width: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 200ms ease-in;
}

.list-enter-active {
  transition-delay: 300ms;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  visibility: hidden;
}
</style>
